import { TaxSectionProps } from ".";
import { EarlyCreditCardConfig, FullSellerRatesHistory } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { CreditCardIcon } from "../../styles/icons/CreditCardIcon";
import { formatPaymentRangeFromApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Text } from "../Sellers/styles";
import { Divider, Header, Section } from "./styles";

interface EarlyCreditCard extends TaxSectionProps {
  earlyCreditCardConfigData: EarlyCreditCardConfig;
  defaultEarlyCreditCardConfigData: EarlyCreditCardConfig;
  actualValue: FullSellerRatesHistory | undefined;
}

export function EarlyCreditCardModalVisualization({
  earlyCreditCardConfigData,
  defaultEarlyCreditCardConfigData,
  colorFinder,
  actualValue,
}: EarlyCreditCard) {
  const delayForRedeem = formatTextView("earlyCreditCardConfigData", "delayForRedeem", formatPaymentRangeFromApi);
  const buyerRates = formatTextView("earlyCreditCardConfigData", "buyerRates", formatPercentageToNumber);
  const sellerRates = formatTextView("earlyCreditCardConfigData", "sellerRates", formatPercentageToNumber);
  function formatTextView(paymentMethod: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean) {
    const pastValue = actualValue?.pastSellerRates?.[paymentMethod][innerValue];
    const laterValue = actualValue?.laterSellerRates?.[paymentMethod][innerValue];
    if (pastValue?.length) {
      return laterValue.map((item: number, index: number) => {
        if (item === pastValue.at(index)) {
          return (
            <Section align="center" gap="0">
              <Section
                borderRadius={index === 0 ? "4px 0 0 0" : "" || index === 10 ? "0 0 0 4px" : ""}
                border="1px solid var(--gray-200)"
                align="center"
                borderRight="none"
                borderBottom={index !== 10 ? "none" : ""}
              >
                <Text
                  display="flex"
                  align="center"
                  justify="center"
                  height="30px"
                  width="30px"
                  fontSize="12px"
                  color="var(--gray-200)"
                >
                  {index + 2}x
                </Text>
              </Section>
              <Section
                borderRadius={index === 0 ? "0 4px 0 0" : "" || index === 10 ? "0 0 4px 0" : ""}
                border="1px solid var(--gray-200)"
                align="center"
                borderBottom={index !== 10 ? "none" : ""}
              >
                <Text
                  height="30px"
                  display="flex"
                  align="center"
                  justify="space-around"
                  width="140px"
                  margin="0 1rem"
                  fontSize="12px"
                  color="black"
                >
                  <Text fontSize=".9rem" color="var(--gray-200)">
                    {formaterAsCurrency ? formater({ value: laterValue.at(index) }) : formater(laterValue.at(index))}
                  </Text>
                </Text>
              </Section>
            </Section>
          )
        } else {
          return (
            <Section align="center" gap="0">
              <Section
                borderRadius={index === 0 ? "4px 0 0 0" : "" || index === 10 ? "0 0 0 4px" : ""}
                border="1px solid var(--gray-200)"
                align="center"
                borderRight="none"
                borderBottom={index !== 10 ? "none" : ""}
              >
                <Text
                  display="flex"
                  align="center"
                  justify="center"
                  height="30px"
                  width="30px"
                  fontSize="12px"
                  color="var(--gray-200)"
                >
                  {index + 2}x
                </Text>
              </Section>
              <Section
                borderRadius={index === 0 ? "0 4px 0 0" : "" || index === 10 ? "0 0 4px 0" : ""}
                border="1px solid var(--gray-200)"
                align="center"
                borderBottom={index !== 10 ? "none" : ""}
              >
                <Text
                  height="30px"
                  display="flex"
                  align="center"
                  justify="space-around"
                  width="140px"
                  margin="0 1rem"
                  fontSize="12px"
                  color="black"
                >
                  <Section gap=".4rem" align="center">
                    <Text fontSize=".9rem" color={colorFinder(pastValue.at(index), defaultEarlyCreditCardConfigData[innerValue].at(index))}>
                      {formaterAsCurrency ? formater({ value: pastValue.at(index) }) : formater(pastValue.at(index))}
                    </Text>
                    <ArrowIcon size={13} />
                    <Text fontSize=".9rem" color={colorFinder(laterValue.at(index), defaultEarlyCreditCardConfigData[innerValue].at(index))}>
                      {formaterAsCurrency ? formater({ value: laterValue.at(index) }) : formater(laterValue.at(index))}
                    </Text>
                  </Section>
                </Text>
              </Section>
            </Section>
          )
        }
      })
    } else if (pastValue === laterValue) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {formaterAsCurrency ? formater({ value: laterValue }) : formater(laterValue)}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultEarlyCreditCardConfigData[innerValue])}>
            {formaterAsCurrency ? formater({ value: pastValue }) : formater(pastValue)}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultEarlyCreditCardConfigData[innerValue])}>
            {formaterAsCurrency ? formater({ value: laterValue }) : formater(laterValue)}
          </Text>
        </Section>
      );
    }
  }
  return (
    <>
      {earlyCreditCardConfigData && (
        <Section flexDir="column" margin="0 0 2rem 0">
          <Section gap=".4rem" margin="1rem 0 0">
            <CreditCardIcon />
            <Header>Cartão parcelado antecipado</Header>
          </Section>
          <Section flexDir="column">
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Tempo de repasse
              </Text>
              {delayForRedeem}
            </Section>
            <Section gap="2rem">
              <Section flexDir="column" gap="0" width="200px">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Taxas buyer
                </Text>
                {buyerRates}
              </Section>
              <Section flexDir="column" gap="0" width="200px">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Taxas seller
                </Text>
                {sellerRates}
              </Section>
            </Section>
            <Section>
            </Section>
          </Section>
          <Divider />
        </Section>
      )}
    </>
  )
}